import { importProvidersFrom, Injector, type EnvironmentProviders } from '@angular/core';
import { Router } from '@angular/router';
import { OKTA_TOKEN_STORAGE_KEYS } from '@core/auth/okta-auth.constants';
import { environment } from '@environments/environment';
import { OktaAuthModule } from '@okta/okta-angular';
import OktaAuth from '@okta/okta-auth-js';

export function provideInternalOktaAuth(): EnvironmentProviders {
  const { issuer, clientId, redirectUri, scopes, pkce } = environment.internalOkta;

  const oktaAuth = new OktaAuth({
    issuer,
    clientId,
    redirectUri,
    scopes:
      typeof scopes === 'string'
        ? scopes.split(',').map((scope) => scope.trim()).filter((scope) => scope.length > 0)
        : [],
    pkce: pkce !== 'false',
    // Isolate from external Okta — shared okta-token-storage caused cross-flow renew hangs.
    tokenManager: {
      storageKey: OKTA_TOKEN_STORAGE_KEYS.internal,
    },
  });

  return importProvidersFrom(
    OktaAuthModule.forRoot({
      oktaAuth,
      onAuthRequired: (_oktaAuth: OktaAuth, injector: Injector) => {
        injector.get(Router).navigate(['/auth/login']);
      },
    }),
  );
}
